import { RootState } from "@/app/stores";
import { getTradingPartner, ITradingPartner } from "@/shared/api/trading";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchTradingPartner = createAsyncThunk<
    ITradingPartner,
    string,
    { state: RootState }
>('socialMarketPartner/fetchTradingPartner', async (id, thunkAPI) => {
    try {
        const response = await getTradingPartner(id)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})